module.exports = __webpack_public_path__ + "static/media/Skills_12.9d3ceb02.png";